module.exports = __webpack_public_path__ + "static/media/88.39dd64ca.png";